// Accounts
export const Accounts_InsertAccountDialog = "Accounts_InsertAccountDialog";
export const AccountRoles_AccountRoleDialog = "AccountRoles_AccountRoleDialog";
export const AccountRestrictions_AccountRestrictionDialog = "AccountRestrictions_AccountRestrictionDialog";

// Dashboard
export const Dashboard_CustomerCard = "Dashboard_CustomerCard";
export const Dashboard_InvoicesCard_LastInvoices = "Dashboard_InvoicesCard_LastInvoices";
export const Dashboard_InvoicesCard_ExpectedPayments = "Dashboard_InvoicesCard_ExpectedPayments";
export const Dashboard_RequirementsCard = "Dashboard_RequirementsCard";
export const Dashboard_PaymentsCard = "Dashboard_PaymentsCard";
export const Dashboard_DashboardMeasuredDataCard_Electricity = "Dashboard_DashboardMeasuredDataCard_Electricity";
export const Dashboard_DashboardMeasuredDataCard_ElectricityProduction = "Dashboard_DashboardMeasuredDataCard_ElectricityProduction";
export const Dashboard_DashboardMeasuredDataCard_Gas = "Dashboard_DashboardMeasuredDataCard_Gas";
export const Dashboard_DashboardMeasuredDataCard_Heat = "Dashboard_DashboardMeasuredDataCard_Heat";
export const Dashboard_DashboardMeasuredDataCard_Charging = "Dashboard_DashboardMeasuredDataCard_Charging";
export const Dashboard_MarketingConsentsDialog = "Dashboard_MarketingConsentsDialog";

// Contract detail
export const ContractDetail_PlaceOfDeliveryNameDialog = "ContractDetail_PlaceOfDeliveryNameDialog";

// Requirement detail
export const RequirementDetail_InsertRequirementDocumentDialog = "RequirementDetail_InsertRequirementDocumentDialog";
export const RequirementDetail_InsertRequirementReactionDialog = "RequirementDetail_InsertRequirementReactionDialog";
export const RequirementDetail_ConfirmMobileDialog = "RequirementDetail_ConfirmMobileDialog";

// Requirement forms
export const SelfReadingFormSection_SelfReading = "SelfReadingFormSection_SelfReading";
export const ComplaintFormSection_Complaint = "ComplaintFormSection_Complaint";
export const DistRateCircuitBreakerFormSection_ContractCard = "DistRateCircuitBreakerFormSection_ContractCard";
export const ReservedCapacityGasFormSection_Capacity = "ReservedCapacityGasFormSection_Capacity";
export const EmaiFormSection_EmailCard = "EmaiFormSection_EmailCard";

// Invoice
export const Invoice_Simulation = "Invoice_Simulation";
export const ReservedCapacityFormSection_PageCard = "ReservedCapacityFormSection_PageCard";
export const PaymentMethodFormSection_PageCard = "PaymentMethodFormSection_PageCard";
export const AdvanceFormSection_PageCard = "AdvanceFormSection_PageCard";

// Contracting
export const BusinessDataSubForm_PageCard = "BusinessDataSubForm_PageCard";

// Exports
export const Exports_ExportDocumentDialog = "Exports_ExportDocumentDialog";
export const Exports_ExportDetailSection = "Exports_ExportDetailSection";

// Shared
export const Shared_ProfileDialog = "Shared_ProfileDialog";